import { render, staticRenderFns } from "./MyAccountSettings.vue?vue&type=template&id=cd7a53aa&scoped=true"
import script from "./MyAccountSettings.vue?vue&type=script&lang=js"
export * from "./MyAccountSettings.vue?vue&type=script&lang=js"
import style0 from "./MyAccountSettings.vue?vue&type=style&index=0&id=cd7a53aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7a53aa",
  null
  
)

export default component.exports